<template lang="pug">
  div(data-testid="content-agent-login")
    section.content-header
      h1 代理操作
      ol.breadcrumb
        li
          router-link(:to="{name: 'top'}")
            span.glyphicon.glyphicon-home
            | TOP
        li.active 代理操作

    section.content

      app-messages(:errorMessages="errors", :successMessages="successes")

      mixin btnbar
        .bcard-btnbar.clearfix(class!=attributes.class)
          .pull-left
            router-link.btn.btn-default(:to="{name: 'top'}", title="戻る"): i.fa.fa-reply
          .pull-right
            app-pagination(:is-loading="loadingPagination", :pagination="pagination", @change="getList")

      +btnbar

      .panel(data-testid="-list-panel")
        .table-responsive
          app-list-sortable-nav(ref="sortableNav")
          loading(v-if="isLoading")
          table.table.table-striped.table-bordered.bcard-table.bcard-personal-proxy-login-table(v-else-if="list.length")
            thead
              tr
                th.bcard-table-td-fullname 氏名
                th.bcard-table-td-groups 組織名
                th.bcard-table-td-post 役職名
                th.td-start-btn
            app-list-sortable(ref="sortableList", v-model="list", repo="agents")
              tr(v-for="item in list", :key="item.id")
                td {{item.full_name}}
                td
                  user-groups(:defgroup="item.defgroup", :groups="item.groups")
                td {{item.post}}
                td
                  button.btn.btn-primary(type="button", @click="openModalConf(item)", :data-testid="'-btn-login_'+item.id") 開始
          .panel-body.text-center(v-else, data-testid="-nodata") 代理操作ができるユーザーはいません。

      +btnbar(class='-bottom')

      app-modal(type="primary", v-model="modalConf.isOpen", data-testid="agent-login-confirm-modal")
        template(slot="title") 代理操作の確認
        p {{modalConf.selectedUser.full_name}} さんの代理操作を開始します。よろしいですか？
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-primary(type="button", @click="agentLogin(modalConf.selectedUser.id); close();", data-testid="-btn-start") 開始
          button.btn.btn-default(type="button", @click="close") キャンセル
</template>

<script>
import Vue from 'vue'
import mixinList from '@/mixins/list'
import AppMessages from '@/components/molecules/AppMessages'
import AppPagination from '@/components/molecules/AppPagination'
import AppModal from '@/components/templates/AppModal'
import Loading from '@/components/molecules/Loading'
import UserGroups from '@/components/molecules/UserGroups'
import AppListSortable from '@/components/organisms/AppListSortable'
import AppListSortableNav from '@/components/organisms/AppListSortableNav'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const AgentRepository = RepositoryFactory.get('agents')

export default {
  name: 'AgentSetting',
  components: { AppMessages, AppPagination, AppModal, Loading, UserGroups, AppListSortable, AppListSortableNav },
  mixins: [ mixinList ],
  data: function () {
    return {
      loadingPagination: true,
      // ローディング
      isLoading: true,
      // 確認モーダル
      modalConf: {
        isOpen: false,
        selectedUser: {}
      }
    }
  },
  // 最初にこの機能に入ってきたときに実行される
  created: function () {
    // 初期データ取得
    this.getList()
  },
  methods: {
    /**
     * 一覧取得処理
     * @param Object options
     *          page: ページ番号
     */
    getList: function (options) {
      const vm = this
      options = options || {}
      // API実行
      this.isLoading = true
      this.loadingPagination = !options.viaPagination
      this.sendListRequest({
        repo: 'agents',
        method: 'getRequesters',
        params: {
          page: options.page || 1
        },
        finally: function () {
          vm.isLoading = false
          vm.loadingPagination = false
        }
      })
    },
    /**
     * 確認モーダルを開く
     * @param selectedUser
     */
    openModalConf: function (selectedUser) {
      this.modalConf.selectedUser = selectedUser
      this.modalConf.isOpen = true
    },
    /**
     * 代理操作を開始する
     */
    agentLogin: function (selectedUserId) {
      const vm = this
      AgentRepository.postLogin({id: selectedUserId})
        .then(function (response) {
          // token保存
          const token = vm.getApiData(response).data.token
          // API
          Vue.ApiAdapter.setApiToken(token)
          // store（時間がかかるので後にする）
          vm.$store.commit('resetState')
          vm.$store.dispatch('setToken', token)

          vm.$router.push({name: 'top', params: {init: true}})
        })
        // エラー時処理
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.bcard-personal-proxy-login-table tbody tr td {
  vertical-align: middle;
}

.td-start-btn {
  width: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/login/AgentLogin.vue